import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  Smartphone,
  Camera,
  Scissors,
  MessageSquare,
  Eye,
  Zap,
  User,
  MapPin,
  BarChart2,
  Timer,
  ChevronDown,
  ChevronUp,
  ShieldCheck
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// SubSystemCard â€” collapsible object sub-system
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SubSystemCard = ({ icon: Icon, title, subtitle, data = {}, colorClass, bgClass, borderClass, defaultOpen = false }) => {
  const [expanded, setExpanded] = useState(defaultOpen);
  if (!data || !Object.keys(data).length) return null;

  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <button onClick={() => setExpanded(!expanded)}
        className={`w-full flex items-center justify-between p-3 ${bgClass} hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${colorClass}`} />
          <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
          {subtitle && <span className={`text-xs ${colorClass} opacity-60`}>({subtitle})</span>}
        </div>
        {expanded ? <ChevronUp className={`w-4 h-4 ${colorClass} opacity-50`} /> : <ChevronDown className={`w-4 h-4 ${colorClass} opacity-50`} />}
      </button>
      {expanded && (
        <div className="bg-white p-4 space-y-2 border-t border-gray-100">
          {Object.entries(data).map(([key, value]) => (
            <div key={key}>
              <span className="text-xs font-medium text-gray-500 capitalize">{key.replace(/_/g, ' ')}: </span>
              {Array.isArray(value) ? (
                <ul className="mt-0.5 space-y-0.5 ml-2">
                  {value.map((item, i) => (
                    <li key={i} className="flex items-start gap-1.5 text-sm text-gray-700">
                      <span className={`${colorClass} mt-0.5 opacity-60`}>•</span>
                      {typeof item === 'string' ? item : JSON.stringify(item)}
                    </li>
                  ))}
                </ul>
              ) : (
                <span className="text-sm text-gray-700">{String(value)}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// RulesList
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const RulesList = ({ icon: Icon, title, items = [], colorClass, bgClass, borderClass }) => {
  if (!items.length) return null;
  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <div className={`flex items-center gap-2 p-3 ${bgClass}`}>
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        <span className="ml-auto text-xs text-gray-400">{items.length} items</span>
      </div>
      <ul className="divide-y divide-gray-100 bg-white">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 p-3">
            <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-gray-50 border border-current`}>
              {i + 1}
            </span>
            <p className="text-sm text-gray-700 leading-relaxed">{typeof item === "string" ? item : JSON.stringify(item)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare il Native Platform Language Engine</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract095View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract095View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};
  const ir = output.platform_native_ir || {};

  const subSystems = [
    { key: 'native_attention_system', icon: Zap, title: 'Attention System', subtitle: 'first second & stop-scrolling', color: 'text-yellow-700', bg: 'bg-yellow-50', border: 'border-yellow-200', open: true },
    { key: 'native_hook_system', icon: Eye, title: 'Hook System', subtitle: 'style, density, delivery', color: 'text-orange-700', bg: 'bg-orange-50', border: 'border-orange-200' },
    { key: 'native_camera_system', icon: Camera, title: 'Camera System', subtitle: 'format, angle, movement', color: 'text-blue-700', bg: 'bg-blue-50', border: 'border-blue-200' },
    { key: 'native_editing_system', icon: Scissors, title: 'Editing System', subtitle: 'cuts, pacing, transitions', color: 'text-indigo-700', bg: 'bg-indigo-50', border: 'border-indigo-200' },
    { key: 'native_subtitle_system', icon: MessageSquare, title: 'Subtitle System', subtitle: 'presence, density, style', color: 'text-purple-700', bg: 'bg-purple-50', border: 'border-purple-200' },
    { key: 'native_speech_system', icon: MessageSquare, title: 'Speech System', subtitle: 'register, speed, imperfections', color: 'text-pink-700', bg: 'bg-pink-50', border: 'border-pink-200' },
    { key: 'native_creator_system', icon: User, title: 'Creator System', subtitle: 'presence, behavior, authenticity', color: 'text-teal-700', bg: 'bg-teal-50', border: 'border-teal-200' },
    { key: 'native_environment_system', icon: MapPin, title: 'Environment System', subtitle: 'style, realism, lighting', color: 'text-green-700', bg: 'bg-green-50', border: 'border-green-200' },
    { key: 'native_observation_delivery', icon: Eye, title: 'Observation Delivery', subtitle: 'how inferences become visible', color: 'text-cyan-700', bg: 'bg-cyan-50', border: 'border-cyan-200' },
    { key: 'native_algorithmic_fit', icon: BarChart2, title: 'Algorithmic Fit', subtitle: 'retention, completion, engagement', color: 'text-lime-700', bg: 'bg-lime-50', border: 'border-lime-200' },
    { key: 'native_duration_system', icon: Timer, title: 'Duration System', subtitle: 'recommended, min, max', color: 'text-amber-700', bg: 'bg-amber-50', border: 'border-amber-200' },
  ];

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <Smartphone className="w-6 h-6 text-violet-600" />
            <h2 className="text-xl font-bold text-gray-800">Native Platform Language Engine</h2>
            <span className="px-2 py-0.5 text-xs bg-violet-100 text-violet-700 rounded-full font-medium">C9.5</span>
          </div>
          <p className="text-sm text-gray-500">Platform Compiler Backend â€” traduzione del brief in grammatica platform-native</p>

          {/* Platform + Mode */}
          {(ir.target_platform || ir.platform_execution_mode) && (
            <div className="flex gap-3 mt-3 flex-wrap">
              {ir.target_platform && (
                <div className="bg-violet-50 border border-violet-200 rounded-lg px-3 py-2">
                  <p className="text-xs text-violet-500">Platform</p>
                  <p className="text-sm font-bold text-violet-700">{ir.target_platform}</p>
                </div>
              )}
              {ir.platform_execution_mode && (
                <div className="bg-violet-50 border border-violet-200 rounded-lg px-3 py-2">
                  <p className="text-xs text-violet-500">Execution Mode</p>
                  <p className="text-sm font-bold text-violet-700">{ir.platform_execution_mode}</p>
                </div>
              )}
              {ir.native_content_format && (
                <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                  <p className="text-xs text-gray-400">Content Format</p>
                  <p className="text-sm font-medium text-gray-700">{ir.native_content_format}</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Sub-Systems */}
        <div className="space-y-3">
          {subSystems.map(({ key, icon, title, subtitle, color, bg, border, open }) => (
            <SubSystemCard
              key={key}
              icon={icon}
              title={title}
              subtitle={subtitle}
              data={ir[key]}
              colorClass={color}
              bgClass={bg}
              borderClass={border}
              defaultOpen={!!open}
            />
          ))}
        </div>

        {/* Rules Lists */}
        <div className="space-y-4">
          <RulesList
            icon={XCircle}
            title="Platform Forbidden Patterns"
            items={ir.platform_forbidden_patterns || []}
            colorClass="text-red-700"
            bgClass="bg-red-50"
            borderClass="border-red-200"
          />
          <RulesList
            icon={CheckCircle2}
            title="Platform Native Rules"
            items={ir.platform_native_rules || []}
            colorClass="text-green-700"
            bgClass="bg-green-50"
            borderClass="border-green-200"
          />
          <RulesList
            icon={Clock}
            title="Implementation Notes"
            items={ir.implementation_notes || []}
            colorClass="text-blue-700"
            bgClass="bg-blue-50"
            borderClass="border-blue-200"
          />
          <RulesList
            icon={ShieldCheck}
            title="Semantic Preservation Checks"
            items={ir.semantic_preservation_checks || []}
            colorClass="text-teal-700"
            bgClass="bg-teal-50"
            borderClass="border-teal-200"
          />
        </div>

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract095View;

